const geojsonData = {
  type: "FeatureCollection",

  features: [
    {
      type: "Feature",
      id: "smfef6d91c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.680711741, 40.735729484],
            [-72.819479621, 40.736803513],
            [-72.819706856, 40.718435166],
            [-72.784344612, 40.691107224],
            [-72.711903511, 40.691367543],
            [-72.681004463, 40.714011403],
            [-72.680711741, 40.735729484],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH17",
      },
    },
    {
      type: "Feature",
      id: "sm8706b70a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.819479621, 40.736803513],
            [-72.680711741, 40.735729484],
            [-72.680068327, 40.783441789],
            [-72.818890175, 40.784427222],
            [-72.819479621, 40.736803513],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH16",
      },
    },
    {
      type: "Feature",
      id: "sm6e1c8eee",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.818890175, 40.784427222],
            [-72.680068327, 40.783441789],
            [-72.679456941, 40.828747365],
            [-72.818329033, 40.829732481],
            [-72.818890175, 40.784427222],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH15",
      },
    },
    {
      type: "Feature",
      id: "sm809afa7e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.818329033, 40.829732481],
            [-72.679456941, 40.828747365],
            [-72.678822171, 40.87575305],
            [-72.817746428, 40.876737838],
            [-72.818329033, 40.829732481],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH14",
      },
    },
    {
      type: "Feature",
      id: "sm0409a24c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.817746428, 40.876737838],
            [-72.678822171, 40.87575305],
            [-72.67820901, 40.921126887],
            [-72.817183656, 40.922111357],
            [-72.817746428, 40.876737838],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH13",
      },
    },
    {
      type: "Feature",
      id: "sm531510a8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.817183656, 40.922111357],
            [-72.67820901, 40.921126887],
            [-72.677591564, 40.966786325],
            [-72.816616952, 40.967770473],
            [-72.817183656, 40.922111357],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH12",
      },
    },
    {
      type: "Feature",
      id: "sm11006e11",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.816616952, 40.967770473],
            [-72.677591564, 40.966786325],
            [-72.677571237, 40.968288944],
            [-72.781254708, 41.053262771],
            [-72.869083727, 41.053541935],
            [-72.869562953, 40.967748172],
            [-72.86880201, 40.968288943],
            [-72.816616952, 40.967770473],
            [-72.816616952, 40.967770473],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH11",
      },
    },
    {
      type: "Feature",
      id: "sma1c4180f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.869562953, 40.967748172],
            [-72.869083727, 41.053541935],
            [-72.928406908, 41.053730493],
            [-72.929159786, 40.943496484],
            [-72.903820931, 40.943397825],
            [-72.869562953, 40.967748172],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH10",
      },
    },
    {
      type: "Feature",
      id: "sm1d4acd15",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.929159786, 40.943496484],
            [-72.928406908, 41.053730493],
            [-72.990840741, 41.053928937],
            [-72.991593316, 40.943739574],
            [-72.929159786, 40.943496484],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH09",
      },
    },
    {
      type: "Feature",
      id: "sm8faf5f5d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.991593316, 40.943739574],
            [-72.990840741, 41.053928937],
            [-73.049798949, 41.054116333],
            [-73.050551239, 40.94396913],
            [-72.991593316, 40.943739574],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH08",
      },
    },
    {
      type: "Feature",
      id: "sm0f3e33a0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.050551239, 40.94396913],
            [-73.049798949, 41.054116333],
            [-73.111595702, 41.054312751],
            [-73.112347693, 40.944209738],
            [-73.050551239, 40.94396913],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH07",
      },
    },
    {
      type: "Feature",
      id: "sm75fde260",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.112347693, 40.944209738],
            [-73.111595702, 41.054312751],
            [-73.171125688, 41.054501964],
            [-73.171740361, 40.944440986],
            [-73.112347693, 40.944209738],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH06",
      },
    },
    {
      type: "Feature",
      id: "sm789ed227",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.171740361, 40.944440986],
            [-73.171125688, 41.054501964],
            [-73.226027411, 41.054676466],
            [-73.226641867, 40.944654747],
            [-73.171740361, 40.944440986],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH05",
      },
    },
    {
      type: "Feature",
      id: "sm78139dc0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.226641867, 40.944654747],
            [-73.226027411, 41.054676466],
            [-73.28613532, 41.054867515],
            [-73.286749538, 40.944888777],
            [-73.226641867, 40.944654747],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH04",
      },
    },
    {
      type: "Feature",
      id: "sm21a279fa",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.286749538, 40.944888777],
            [-73.28613532, 41.054867515],
            [-73.345327939, 41.055055654],
            [-73.346078798, 40.945119776],
            [-73.286749538, 40.944888777],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH03",
      },
    },
    {
      type: "Feature",
      id: "sm962edb67",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.346078798, 40.945119776],
            [-73.345327939, 41.055055654],
            [-73.405071878, 41.055245545],
            [-73.405822449, 40.945352387],
            [-73.346078798, 40.945119776],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH02",
      },
    },
    {
      type: "Feature",
      id: "sm8931e462",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.405822449, 40.945352387],
            [-73.405071878, 41.055245545],
            [-73.432881294, 41.055333935],
            [-73.470646797, 41.029957693],
            [-73.470646797, 40.972436552],
            [-73.436657845, 40.945472444],
            [-73.436657845, 40.945472444],
            [-73.405822449, 40.945352387],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH01",
      },
    },
    {
      type: "Feature",
      id: "sme969e5f2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.406062794, 40.695135688],
            [-73.406871404, 40.802202289],
            [-73.469442642, 40.802433335],
            [-73.469960155, 40.722078044],
            [-73.469960155, 40.722078044],
            [-73.434597912, 40.695011902],
            [-73.406062794, 40.695135688],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH28",
      },
    },
    {
      type: "Feature",
      id: "smdee47a53",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.928621246, 40.800436308],
            [-72.927841638, 40.69721019],
            [-72.894551218, 40.6973546],
            [-72.866398752, 40.719996425],
            [-72.865696321, 40.800203948],
            [-72.928621246, 40.800436308],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH37",
      },
    },
    {
      type: "Feature",
      id: "sm32766e8a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.927841638, 40.69721019],
            [-72.928621246, 40.800436308],
            [-72.98767048, 40.800654355],
            [-72.986887291, 40.696954056],
            [-72.927841638, 40.69721019],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH36",
      },
    },
    {
      type: "Feature",
      id: "sm358c8b00",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.986887291, 40.696954056],
            [-72.98767048, 40.800654355],
            [-73.048797387, 40.800880073],
            [-73.048010491, 40.696688909],
            [-72.986887291, 40.696954056],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH35",
      },
    },
    {
      type: "Feature",
      id: "sm96599a13",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.048010491, 40.696688909],
            [-73.048797387, 40.800880073],
            [-73.1066705, 40.801093776],
            [-73.107344421, 40.696431522],
            [-73.048010491, 40.696688909],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH34",
      },
    },
    {
      type: "Feature",
      id: "sm364552c3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.107344421, 40.696431522],
            [-73.1066705, 40.801093776],
            [-73.163268054, 40.801302768],
            [-73.162474216, 40.696192372],
            [-73.107344421, 40.696431522],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH33",
      },
    },
    {
      type: "Feature",
      id: "smd38d9217",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.162474216, 40.696192372],
            [-73.163268054, 40.801302768],
            [-73.22099896, 40.801515944],
            [-73.220201622, 40.695941953],
            [-73.162474216, 40.696192372],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH32",
      },
    },
    {
      type: "Feature",
      id: "sm5c3dfc19",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.220201622, 40.695941953],
            [-73.22099896, 40.801515944],
            [-73.284868597, 40.801751787],
            [-73.284067385, 40.695664905],
            [-73.220201622, 40.695941953],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH31",
      },
    },
    {
      type: "Feature",
      id: "smb1967eae",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.284067385, 40.695664905],
            [-73.284868597, 40.801751787],
            [-73.347423836, 40.801982776],
            [-73.34661883, 40.695393557],
            [-73.284067385, 40.695664905],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH30",
      },
    },
    {
      type: "Feature",
      id: "sm4671aa90",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.34661883, 40.695393557],
            [-73.347423836, 40.801982776],
            [-73.406871404, 40.802202289],
            [-73.406062794, 40.695135688],
            [-73.34661883, 40.695393557],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH29",
      },
    },
    {
      type: "Feature",
      id: "smbe39caed",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.927597056, 40.903615644],
            [-72.928262471, 40.800434983],
            [-72.865696321, 40.800203948],
            [-72.865025461, 40.876716041],
            [-72.901417673, 40.903448722],
            [-72.927597056, 40.903615644],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH18",
      },
    },
    {
      type: "Feature",
      id: "sm7a565302",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.406069289, 40.802199327],
            [-73.405395581, 40.906662062],
            [-73.430478038, 40.906821983],
            [-73.468930186, 40.881907698],
            [-73.469442642, 40.802433335],
            [-73.406069289, 40.802199327],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH27",
      },
    },
    {
      type: "Feature",
      id: "sm519350e1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.405395581, 40.906662062],
            [-73.406069289, 40.802199327],
            [-73.345002835, 40.801973836],
            [-73.344330187, 40.90627272],
            [-73.405395581, 40.906662062],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH26",
      },
    },
    {
      type: "Feature",
      id: "sm28d2b288",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.344330187, 40.90627272],
            [-73.345002835, 40.801973836],
            [-73.283283246, 40.801745933],
            [-73.28261167, 40.905879212],
            [-73.344330187, 40.90627272],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH25",
      },
    },
    {
      type: "Feature",
      id: "sm18136d64",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.28261167, 40.905879212],
            [-73.283283246, 40.801745933],
            [-73.220039675, 40.801512402],
            [-73.219369196, 40.905475985],
            [-73.28261167, 40.905879212],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH24",
      },
    },
    {
      type: "Feature",
      id: "smce7ae479",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.219369196, 40.905475985],
            [-73.220039675, 40.801512402],
            [-73.163689191, 40.801304323],
            [-73.16301969, 40.905116704],
            [-73.219369196, 40.905475985],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH23",
      },
    },
    {
      type: "Feature",
      id: "sm1bb32322",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.16301969, 40.905116704],
            [-73.163689191, 40.801304323],
            [-73.106025739, 40.801091395],
            [-73.105357239, 40.90474905],
            [-73.16301969, 40.905116704],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH22",
      },
    },
    {
      type: "Feature",
      id: "sma08c8d89",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.105357239, 40.90474905],
            [-73.106025739, 40.801091395],
            [-73.049048915, 40.800881002],
            [-73.048381404, 40.904385772],
            [-73.105357239, 40.90474905],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH21",
      },
    },
    {
      type: "Feature",
      id: "sm6fc6d4f3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.048381404, 40.904385772],
            [-73.049048915, 40.800881002],
            [-72.987955666, 40.800655408],
            [-72.987289215, 40.903996246],
            [-73.048381404, 40.904385772],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH20",
      },
    },
    {
      type: "Feature",
      id: "sm024274f4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.987289215, 40.903996246],
            [-72.987955666, 40.800655408],
            [-72.928262471, 40.800434983],
            [-72.927597056, 40.903615644],
            [-72.987289215, 40.903996246],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH19",
      },
    },
    {
      type: "Feature",
      id: "sm5e4e298f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.835698006, 40.547724494],
            [-73.675825218, 40.546502684],
            [-73.675619698, 40.594273856],
            [-73.835076429, 40.594669544],
            [-73.835698006, 40.547724494],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH60",
      },
    },
    {
      type: "Feature",
      id: "sm75c0bbe7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.15953649, 40.595474677],
            [-74.323336988, 40.595881137],
            [-74.323460526, 40.549995143],
            [-74.159790683, 40.549473157],
            [-74.15953649, 40.595474677],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH71",
      },
    },
    {
      type: "Feature",
      id: "sm0aafd83d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.159790683, 40.549473157],
            [-73.997727904, 40.548956292],
            [-73.997473079, 40.595072525],
            [-74.15953649, 40.595474677],
            [-74.159790683, 40.549473157],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH70",
      },
    },
    {
      type: "Feature",
      id: "smcdcb946f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.997727904, 40.548956292],
            [-73.996273942, 40.548951655],
            [-73.996273942, 40.548951655],
            [-73.835698006, 40.547724494],
            [-73.835076429, 40.594669544],
            [-73.997473079, 40.595072525],
            [-73.997727904, 40.548956292],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH61",
      },
    },
    {
      type: "Feature",
      id: "sma762cc87",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.836264977, 41.058144072],
            [-73.997621941, 41.058199553],
            [-73.997650357, 41.011193276],
            [-73.836293393, 41.011137756],
            [-73.836264977, 41.058144072],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH91",
      },
    },
    {
      type: "Feature",
      id: "sm73a48318",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.671496, 41.011081052],
            [-73.536028376, 41.011034439],
            [-73.536049787, 41.034101421],
            [-73.569180433, 41.058052238],
            [-73.671467584, 41.058087408],
            [-73.671496, 41.011081052],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH101",
      },
    },
    {
      type: "Feature",
      id: "sm9b9fa724",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.671467584, 41.058087408],
            [-73.836264977, 41.058144072],
            [-73.836293393, 41.011137756],
            [-73.671496, 41.011081052],
            [-73.671467584, 41.058087408],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH92",
      },
    },
    {
      type: "Feature",
      id: "sme34d0c97",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.535983509, 40.962669943],
            [-73.536028376, 41.011034439],
            [-73.671473143, 41.011081044],
            [-73.671502359, 40.962716608],
            [-73.535983509, 40.962669943],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH100",
      },
    },
    {
      type: "Feature",
      id: "sm52492b01",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.671502359, 40.962716608],
            [-73.67153085, 40.915518803],
            [-73.535939755, 40.91547208],
            [-73.535983509, 40.962669943],
            [-73.671502359, 40.962716608],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH99",
      },
    },
    {
      type: "Feature",
      id: "sm8dc33fe8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.67153085, 40.915518803],
            [-73.671558874, 40.869061415],
            [-73.535896719, 40.869014635],
            [-73.535939755, 40.91547208],
            [-73.67153085, 40.915518803],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH98",
      },
    },
    {
      type: "Feature",
      id: "smb79d6cab",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.671558874, 40.869061415],
            [-73.671586468, 40.823284774],
            [-73.569523756, 40.823348183],
            [-73.535878126, 40.848933762],
            [-73.535896719, 40.869014635],
            [-73.671558874, 40.869061415],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH97",
      },
    },
    {
      type: "Feature",
      id: "sm59920bab",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.811649129, 40.868063645],
            [-73.811566297, 40.848674061],
            [-73.778607312, 40.823218284],
            [-73.671586468, 40.823284774],
            [-73.671559505, 40.868015338],
            [-73.811649129, 40.868063645],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH96",
      },
    },
    {
      type: "Feature",
      id: "sm53b4f127",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.671559505, 40.868015338],
            [-73.671531014, 40.915247768],
            [-73.811851006, 40.91529612],
            [-73.811649129, 40.868063645],
            [-73.671559505, 40.868015338],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH95",
      },
    },
    {
      type: "Feature",
      id: "sm36b94ab1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.671531014, 40.915247768],
            [-73.671503145, 40.961415826],
            [-73.812048474, 40.961464222],
            [-73.811851006, 40.91529612],
            [-73.671531014, 40.915247768],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH94",
      },
    },
    {
      type: "Feature",
      id: "sm5358e3f8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.812252942, 41.00923514],
            [-73.812252942, 41.00923514],
            [-73.812048474, 40.961464222],
            [-73.671503145, 40.961415826],
            [-73.671473143, 41.011081044],
            [-73.812270621, 41.01112949],
            [-73.812252942, 41.00923514],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH93",
      },
    },
    {
      type: "Feature",
      id: "sm1ad22c05",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.862377463, 41.011146731],
            [-73.997650357, 41.011193276],
            [-73.997679796, 40.962459487],
            [-73.862406902, 40.962412907],
            [-73.862377463, 41.011146731],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH90",
      },
    },
    {
      type: "Feature",
      id: "smd8cc882c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.997679796, 40.962459487],
            [-73.997707973, 40.915780616],
            [-73.86021325, 40.915733238],
            [-73.860609361, 40.962412288],
            [-73.997679796, 40.962459487],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH89",
      },
    },
    {
      type: "Feature",
      id: "smdd44769a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.997707973, 40.915780616],
            [-73.997736153, 40.869063316],
            [-73.859817093, 40.869015758],
            [-73.86021325, 40.915733238],
            [-73.997707973, 40.915780616],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH88",
      },
    },
    {
      type: "Feature",
      id: "sm1f846d91",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.997736153, 40.869063316],
            [-73.997764025, 40.822825505],
            [-73.894993725, 40.823218281],
            [-73.859631481, 40.847115823],
            [-73.859817093, 40.869015758],
            [-73.997736153, 40.869063316],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH87",
      },
    },
    {
      type: "Feature",
      id: "sma39f1734",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.134598921, 40.86878514],
            [-74.134289684, 40.847635239],
            [-74.09892744, 40.822438869],
            [-73.997764025, 40.822825505],
            [-73.997735631, 40.869929651],
            [-74.134598921, 40.86878514],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH86",
      },
    },
    {
      type: "Feature",
      id: "sm1110b0d6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.997735631, 40.869929651],
            [-73.997706873, 40.917602342],
            [-74.135296238, 40.916452587],
            [-74.134598921, 40.86878514],
            [-73.997735631, 40.869929651],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH85",
      },
    },
    {
      type: "Feature",
      id: "smfe1a3886",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.997706873, 40.917602342],
            [-73.997679808, 40.962438445],
            [-74.135970129, 40.962486063],
            [-74.135296238, 40.916452587],
            [-73.997706873, 40.917602342],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH84",
      },
    },
    {
      type: "Feature",
      id: "sm5020e015",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.136692944, 41.011825814],
            [-74.136692944, 41.011825814],
            [-74.135970129, 40.962486063],
            [-73.997679808, 40.962438445],
            [-73.997649747, 41.012202594],
            [-74.136684418, 41.012250433],
            [-74.136692944, 41.011825814],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH83",
      },
    },
    {
      type: "Feature",
      id: "smdeaa6f0e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.997649747, 41.012202594],
            [-73.997621941, 41.058199553],
            [-74.157574352, 41.058254551],
            [-74.158498272, 41.012257939],
            [-73.997649747, 41.012202594],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH82",
      },
    },
    {
      type: "Feature",
      id: "smfd15f21f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.157574352, 41.058254551],
            [-74.322087234, 41.058311117],
            [-74.322221927, 41.008627397],
            [-74.182057266, 41.008411099],
            [-74.182011548, 41.012343937],
            [-74.158501942, 41.012075155],
            [-74.157574352, 41.058254551],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH81",
      },
    },
    {
      type: "Feature",
      id: "sm878d92e6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.322221927, 41.008627397],
            [-74.32234836, 40.961956375],
            [-74.182599592, 40.961740566],
            [-74.182057266, 41.008411099],
            [-74.322221927, 41.008627397],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH80",
      },
    },
    {
      type: "Feature",
      id: "smc43b7c70",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.32234836, 40.961956375],
            [-74.322474765, 40.915262937],
            [-74.183141794, 40.915047618],
            [-74.182599592, 40.961740566],
            [-74.32234836, 40.961956375],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH79",
      },
    },
    {
      type: "Feature",
      id: "sm4fe821d2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.322474765, 40.915262937],
            [-74.322596934, 40.870102716],
            [-74.183665828, 40.869887872],
            [-74.183141794, 40.915047618],
            [-74.322474765, 40.915262937],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH78",
      },
    },
    {
      type: "Feature",
      id: "sm1b800aff",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.322596934, 40.870102716],
            [-74.322717656, 40.8254472],
            [-74.184183654, 40.825232825],
            [-74.183665828, 40.869887872],
            [-74.322596934, 40.870102716],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH77",
      },
    },
    {
      type: "Feature",
      id: "sm37d6b9c1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.322717656, 40.8254472],
            [-74.322845316, 40.778192701],
            [-74.184731239, 40.777978823],
            [-74.184183654, 40.825232825],
            [-74.322717656, 40.8254472],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH76",
      },
    },
    {
      type: "Feature",
      id: "sm9532dd75",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.322845316, 40.778192701],
            [-74.322977218, 40.729332604],
            [-74.185305143, 40.728417441],
            [-74.184731239, 40.777978823],
            [-74.322845316, 40.778192701],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH75",
      },
    },
    {
      type: "Feature",
      id: "sm78284118",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.322977218, 40.729332604],
            [-74.323100636, 40.683582542],
            [-74.18583451, 40.682669449],
            [-74.185305143, 40.728417441],
            [-74.322977218, 40.729332604],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH74",
      },
    },
    {
      type: "Feature",
      id: "sm23d6b495",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.323100636, 40.683582542],
            [-74.323215728, 40.640890694],
            [-74.186328164, 40.639979537],
            [-74.18583451, 40.682669449],
            [-74.323100636, 40.683582542],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH73",
      },
    },
    {
      type: "Feature",
      id: "sm197088c2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.135859557, 40.595415924],
            [-73.996273942, 40.59506955],
            [-73.996273942, 40.640195326],
            [-74.135662976, 40.640195326],
            [-74.135662976, 40.597456652],
            [-74.135850772, 40.597457131],
            [-74.135859557, 40.595415924],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH69",
      },
    },
    {
      type: "Feature",
      id: "sm624c51f6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.186818067, 40.597586994],
            [-74.186818067, 40.597586994],
            [-74.186328164, 40.639979537],
            [-74.323215728, 40.640890694],
            [-74.323336988, 40.595881137],
            [-74.186827103, 40.595542397],
            [-74.186818067, 40.597586994],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH72",
      },
    },
    {
      type: "Feature",
      id: "sm5c1157d0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.996273942, 40.640195326],
            [-73.996273942, 40.688113483],
            [-74.135662977, 40.688113483],
            [-74.135662976, 40.640195326],
            [-73.996273942, 40.640195326],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH68",
      },
    },
    {
      type: "Feature",
      id: "sm6486ce81",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.996273942, 40.688113483],
            [-73.996273942, 40.734956624],
            [-74.135662977, 40.734956624],
            [-74.135662977, 40.688113483],
            [-73.996273942, 40.688113483],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH67",
      },
    },
    {
      type: "Feature",
      id: "smc16eca73",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.996273942, 40.734956624],
            [-73.996273942, 40.781376857],
            [-74.100987379, 40.781376857],
            [-74.135662977, 40.756415381],
            [-74.135662977, 40.734956624],
            [-73.996273942, 40.734956624],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH66",
      },
    },
    {
      type: "Feature",
      id: "smb6c5b66f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.861990578, 40.735997208],
            [-73.862034744, 40.756675446],
            [-73.894650405, 40.781376857],
            [-73.996273942, 40.781376857],
            [-73.996273942, 40.735997208],
            [-73.861990578, 40.735997208],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH65",
      },
    },
    {
      type: "Feature",
      id: "sm7dcb106c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.996273942, 40.735997208],
            [-73.996273942, 40.686969363],
            [-73.861886269, 40.687134257],
            [-73.861990578, 40.735997208],
            [-73.996273942, 40.735997208],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH64",
      },
    },
    {
      type: "Feature",
      id: "sm54da719e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.996273942, 40.686969363],
            [-73.996273942, 40.640077292],
            [-73.86178624, 40.640242424],
            [-73.861886269, 40.687134257],
            [-73.996273942, 40.686969363],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH63",
      },
    },
    {
      type: "Feature",
      id: "sm6e92164d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.811674619, 40.594611473],
            [-73.675619698, 40.594273856],
            [-73.675415517, 40.641700043],
            [-73.812355516, 40.642039616],
            [-73.811566298, 40.595762176],
            [-73.811669667, 40.595762176],
            [-73.811674619, 40.594611473],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH59",
      },
    },
    {
      type: "Feature",
      id: "sm0d07241e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.861697507, 40.598618369],
            [-73.86178624, 40.640242424],
            [-73.996273942, 40.640077292],
            [-73.996273942, 40.59506955],
            [-73.861714217, 40.594735645],
            [-73.861697507, 40.598618369],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH62",
      },
    },
    {
      type: "Feature",
      id: "sm9d5e4dce",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.675415517, 40.641700043],
            [-73.675211373, 40.68908405],
            [-73.813164211, 40.689425891],
            [-73.812355516, 40.642039616],
            [-73.675415517, 40.641700043],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH58",
      },
    },
    {
      type: "Feature",
      id: "sm301424bf",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.675211373, 40.68908405],
            [-73.675018602, 40.733797234],
            [-73.813927851, 40.734141214],
            [-73.813164211, 40.689425891],
            [-73.675211373, 40.68908405],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH57",
      },
    },
    {
      type: "Feature",
      id: "smda40e12e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.675018602, 40.733797234],
            [-73.674806608, 40.782934648],
            [-73.780667251, 40.783196596],
            [-73.814312881, 40.756675444],
            [-73.813927851, 40.734141214],
            [-73.675018602, 40.733797234],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH56",
      },
    },
    {
      type: "Feature",
      id: "sm9253e5ac",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.537682439, 40.732569558],
            [-73.537594741, 40.75303446],
            [-73.570553725, 40.782676677],
            [-73.674806608, 40.782934648],
            [-73.67502243, 40.732909658],
            [-73.537682439, 40.732569558],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH55",
      },
    },
    {
      type: "Feature",
      id: "sm86b31238",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.67502243, 40.732909658],
            [-73.675215362, 40.688158444],
            [-73.537874119, 40.687818112],
            [-73.537682439, 40.732569558],
            [-73.67502243, 40.732909658],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH54",
      },
    },
    {
      type: "Feature",
      id: "sma0bf7a99",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.675215362, 40.688158444],
            [-73.675417505, 40.641238616],
            [-73.53807495, 40.640898041],
            [-73.537874119, 40.687818112],
            [-73.675215362, 40.688158444],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH53",
      },
    },
    {
      type: "Feature",
      id: "smf3e3faec",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.53812697, 40.592636298],
            [-73.538281386, 40.592633803],
            [-73.53807495, 40.640898041],
            [-73.675417505, 40.641238616],
            [-73.6756327, 40.591252797],
            [-73.538134393, 40.590911581],
            [-73.53812697, 40.592636298],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH52",
      },
    },
    {
      type: "Feature",
      id: "sm3bb2181a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.6756327, 40.591252797],
            [-73.675825218, 40.546502684],
            [-73.475362965, 40.544970642],
            [-73.474756796, 40.590754302],
            [-73.6756327, 40.591252797],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH51",
      },
    },
    {
      type: "Feature",
      id: "smb8582db0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.475362965, 40.544970642],
            [-73.404397043, 40.544428273],
            [-73.403054399, 40.645796233],
            [-73.436657851, 40.645796233],
            [-73.474423354, 40.619220307],
            [-73.473736708, 40.59367661],
            [-73.474718301, 40.593660751],
            [-73.475362965, 40.544970642],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH50",
      },
    },
    {
      type: "Feature",
      id: "sm19ec249a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.404397043, 40.544428273],
            [-73.346690128, 40.543987235],
            [-73.345341646, 40.645796234],
            [-73.403054399, 40.645796233],
            [-73.404397043, 40.544428273],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH49",
      },
    },
    {
      type: "Feature",
      id: "sm41e5afa8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.346690128, 40.543987235],
            [-73.284918998, 40.543515132],
            [-73.283564268, 40.645796234],
            [-73.345341646, 40.645796234],
            [-73.346690128, 40.543987235],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH48",
      },
    },
    {
      type: "Feature",
      id: "sm1a343a2c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.284918998, 40.543515132],
            [-73.224472684, 40.543053151],
            [-73.22311184, 40.645796234],
            [-73.283564268, 40.645796234],
            [-73.284918998, 40.543515132],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH47",
      },
    },
    {
      type: "Feature",
      id: "smd9fd15e9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.224472684, 40.543053151],
            [-73.164746231, 40.542596669],
            [-73.164746232, 40.645796234],
            [-73.22311184, 40.645796234],
            [-73.224472684, 40.543053151],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH46",
      },
    },
    {
      type: "Feature",
      id: "smbb0a5b3f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.164746231, 40.542596669],
            [-73.102948136, 40.54212435],
            [-73.102948136, 40.645796234],
            [-73.164746232, 40.645796234],
            [-73.164746231, 40.542596669],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH45",
      },
    },
    {
      type: "Feature",
      id: "sm6175bd2b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.102948136, 40.54212435],
            [-73.043209976, 40.541667772],
            [-73.043209977, 40.645796234],
            [-73.102948136, 40.645796234],
            [-73.102948136, 40.54212435],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH44",
      },
    },
    {
      type: "Feature",
      id: "sm34fd210d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.043209976, 40.541667772],
            [-72.98003859, 40.541184951],
            [-72.98003859, 40.645796234],
            [-73.043209977, 40.645796234],
            [-73.043209976, 40.541667772],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH43",
      },
    },
    {
      type: "Feature",
      id: "sm4372cafc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.98003859, 40.541184951],
            [-72.920300431, 40.540728367],
            [-72.920300431, 40.645796234],
            [-72.98003859, 40.645796234],
            [-72.98003859, 40.541184951],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH42",
      },
    },
    {
      type: "Feature",
      id: "smdb3287de",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.920300431, 40.540728367],
            [-72.867428727, 40.540324261],
            [-72.867428727, 40.645796234],
            [-72.920300431, 40.645796234],
            [-72.920300431, 40.540728367],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH41",
      },
    },
    {
      type: "Feature",
      id: "smd88bfa3c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.867428727, 40.540324261],
            [-72.806317276, 40.539857175],
            [-72.806317277, 40.645796234],
            [-72.867428727, 40.645796234],
            [-72.867428727, 40.540324261],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH40",
      },
    },
    {
      type: "Feature",
      id: "sm2df2f79c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.806317276, 40.539857175],
            [-72.745892472, 40.539395333],
            [-72.745892472, 40.645796234],
            [-72.806317277, 40.645796234],
            [-72.806317276, 40.539857175],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH39",
      },
    },
    {
      type: "Feature",
      id: "sm52198b87",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.745892472, 40.539395333],
            [-72.682034437, 40.538907247],
            [-72.679974501, 40.615050574],
            [-72.718426649, 40.645796234],
            [-72.745892472, 40.645796234],
            [-72.745892472, 40.539395333],
          ],
        ],
      },
      properties: {
        Unit_Number: "TH38",
      },
    },
  ],
};

export default geojsonData;
